import { createReducer } from '../../utils';
import types from './types';

export const initialState = {
    loading: false,
    errors: null,
    previousPage: {
        name: null
    },
    currentPage: {
        name: null
    },
    isServerRendering: true
};

const ACTION_HANDLERS = {
    [types.START_ROUTE_LOADING]: state => ({
        ...state,
        loading: true,
        errors: null
    }),

    [types.END_ROUTE_LOADING]: (state, action) => ({
        ...state,
        loading: false,
        currentPage: {
            name: action.payload.name,
            details: action.payload.details
        },
        previousPage: {
            name: state.currentPage.name,
            details: state.currentPage.details
        }
    }),

    [types.ERRORS_ON_ROUTE_LOADING]: (state, action) => ({
        ...state,
        loading: false,
        errors: action.payload
    }),

    [types.RENDER_NEXT_ROUTES_ON_CLIENT]: state => ({
        ...state,
        isServerRendering: false
    })
};

export default createReducer(ACTION_HANDLERS, initialState);
